import { isDateAllowed } from './isDateAllowed';

export const testStartDate = (
  startDate: Date | null | undefined,
  disabledDates: Date[]
): boolean => {
  if (!startDate) {
    return true;
  }

  return isDateAllowed(startDate, disabledDates);
};
